import React, { useState } from 'react';
import { useCookies } from '../context/CookieContext';
import '../assest/CookieSettings.css';

const CookieSettings = () => {
  const { 
    cookiePreferences, 
    cookieSettingsOpen, 
    closeCookieSettings, 
    updateCookiePreferences 
  } = useCookies();

  const [localPreferences, setLocalPreferences] = useState(cookiePreferences);

  const handleToggle = (key) => {
    if (key === 'necessary') return; // Gerekli çerezler değiştirilemez
    
    setLocalPreferences(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleSave = () => {
    updateCookiePreferences(localPreferences);
    closeCookieSettings();
  };

  const handleCancel = () => {
    setLocalPreferences(cookiePreferences);
    closeCookieSettings();
  };

  if (!cookieSettingsOpen) {
    return null;
  }

  return (
    <div className="cookie-settings-overlay">
      <div className="cookie-settings-modal">
        <div className="cookie-settings-header">
          <h2>Çerez Ayarları</h2>
          <button 
            className="cookie-settings-close" 
            onClick={closeCookieSettings}
          >
            ×
          </button>
        </div>

        <div className="cookie-settings-content">
          <p className="cookie-settings-description">
            Bu web sitesi deneyiminizi geliştirmek için farklı türde çerezler kullanmaktadır. 
            Aşağıdaki seçeneklerden istediğinizi seçebilirsiniz.
          </p>

          <div className="cookie-category">
            <div className="cookie-category-header">
              <div className="cookie-category-info">
                <h3>Gerekli Çerezler</h3>
                <p>Bu çerezler web sitesinin temel işlevleri için gereklidir ve devre dışı bırakılamaz.</p>
              </div>
              <div className="cookie-toggle">
                <input
                  type="checkbox"
                  checked={localPreferences.necessary}
                  disabled
                  readOnly
                />
                <span className="toggle-label">Aktif</span>
              </div>
            </div>
          </div>

          <div className="cookie-category">
            <div className="cookie-category-header">
              <div className="cookie-category-info">
                <h3>Analitik Çerezler</h3>
                <p>Bu çerezler web sitesinin nasıl kullanıldığını anlamamıza yardımcı olur ve performansı iyileştirir.</p>
              </div>
              <div className="cookie-toggle">
                <input
                  type="checkbox"
                  checked={localPreferences.analytics}
                  onChange={() => handleToggle('analytics')}
                />
                <span className="toggle-label">
                  {localPreferences.analytics ? 'Aktif' : 'Pasif'}
                </span>
              </div>
            </div>
          </div>

          <div className="cookie-category">
            <div className="cookie-category-header">
              <div className="cookie-category-info">
                <h3>Pazarlama Çerezleri</h3>
                <p>Bu çerezler size ilgi alanlarınıza uygun reklamlar göstermek için kullanılır.</p>
              </div>
              <div className="cookie-toggle">
                <input
                  type="checkbox"
                  checked={localPreferences.marketing}
                  onChange={() => handleToggle('marketing')}
                />
                <span className="toggle-label">
                  {localPreferences.marketing ? 'Aktif' : 'Pasif'}
                </span>
              </div>
            </div>
          </div>

          <div className="cookie-category">
            <div className="cookie-category-header">
              <div className="cookie-category-info">
                <h3>Tercih Çerezleri</h3>
                <p>Bu çerezler dil, bölge ve diğer kişiselleştirme seçeneklerinizi hatırlar.</p>
              </div>
              <div className="cookie-toggle">
                <input
                  type="checkbox"
                  checked={localPreferences.preferences}
                  onChange={() => handleToggle('preferences')}
                />
                <span className="toggle-label">
                  {localPreferences.preferences ? 'Aktif' : 'Pasif'}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="cookie-settings-footer">
          <button 
            className="cookie-btn cookie-btn-secondary" 
            onClick={handleCancel}
          >
            İptal
          </button>
          <button 
            className="cookie-btn cookie-btn-primary" 
            onClick={handleSave}
          >
            Kaydet
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieSettings;
